import React, {Component} from 'react';
import {List, Toast,NavBar,Modal} from 'antd-mobile';
import {sendOrderPreview,orderPreview,confirmOrder,resendorder,closeOrder} from "../../../service/shuntService";
import {translate} from '../../../service/homeService';
import moment from "moment";
import BMap from "BMap";
import './index.less';
import {connect} from "react-redux";
//地图相关代码
let index = 0; //设置头部出发城市数组的索引初始值
let addressData = [];//设置地图解析的经纬度
let SitesData = [];//起止点的数组
let shuntOrderIds = [];
const positionIcon = require('../../../common/image/positionmin.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class BillView extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.IdData=[];
        this.mapView = undefined;
        this.state = {
            showModal:false,
            show:true,//发单预览地址，默认是显示
            dispatch:this.props.location.state.dispatch,//传递过来的0是确认发单页面，1是派单调度，2是城内调度
            refuse:this.props.location.state.refuse,//从上个页面传递过来
            data:this.props.location.state.data,//发单数据
            dispatchData:this.props.location.state.dispatchData,//派单调度
            amount:0,
            combineStartTime:'',
            //派单调度
            dispatchStartTime:'',
            dispatchPrice:0,
            //城内调度
            cityDispatch:1,//从城内调度传过来，根据这个判断是否显示订单号
            //地图相关
            addressData:[],
            sendOrder:false,
        };
    }

    componentDidMount() {
        if(this.props.location.state.data){
            shuntOrderIds = [];
            this.props.location.state.data.map((res)=>{
                shuntOrderIds.push(res.shuntOrderId)
            });
        }

        this.totalAmount();
        this.getOrderDetail();
        let map = new BMap.Map("allmap"); 
        map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
        map.enableContinuousZoom();  
        addressData = [];
        SitesData = [];
        if(this.state.data){
            this.state.data.forEach(e=>{
                addressData.push({
                   location:e.addressLocation,
                   locationName:e.orderType == "接" || e.orderType == 0 ?  e.startAddress : e.endAddress
                })
                SitesData.push({
                    location:e.vicinageStationLacation,
                    locationName:e.vicinageStationName
                 })
                this.IdData.push({
                    "shuntOrderId":e.shuntOrderId,
                    "price":e.price
                })
            })
            // setTimeout(() => {
            //     let point = this.props.history.location.state.data[0].vicinageStationLacation.split(',').reverse();
            //     let pointName = this.props.history.location.state.data[0].vicinageStation;
            //     let addressName = new BMap.Label(pointName,{offset:new BMap.Size(20,-10)})
            //     let address = new BMap.Point(point[0], point[1]);
            //     var myIcon = new BMap.Icon(positionIcon, new BMap.Size(100,157), {
            //         offset: new BMap.Size(10, 25),
            //         imageOffset: new BMap.Size(0, 0 -  index * 25)
            //     });
            //     let marker = new BMap.Marker(address,{icon:myIcon });
            //     this.mapView.centerAndZoom(new BMap.Point(point[0],point[1]), 13);
            //     this.mapView.addOverlay(marker);
            //     marker.setLabel(addressName);
            // }, 0);
        }else if(this.state.dispatchData){
            this.state.dispatchData[0].orderDetails.forEach(e=>{
                    addressData.push({
                         location:e.addressLocation,
                         locationName:e.address
                    })
                    SitesData.push({
                        location:e.vicinageStationLacation,
                        locationName:e.vicinageStationName
                     })
            })
            // setTimeout(() => {
            //     let point = this.props.history.location.state.dispatchData[0].orderDetails[0].vicinageStationLacation.split(',').reverse();
            //     let pointName = this.props.history.location.state.dispatchData[0].orderDetails[0].vicinageStation;
            //     let addressName = new BMap.Label(pointName,{offset:new BMap.Size(20,-10)})
            //     let address = new BMap.Point(point[0], point[1]);
            //     var myIcon = new BMap.Icon(positionIcon, new BMap.Size(100,157), {
            //         offset: new BMap.Size(10, 25),
            //         imageOffset: new BMap.Size(0, 0 -  index * 25)
            //     });
            //     let marker = new BMap.Marker(address,{icon:myIcon });
            //     this.mapView.centerAndZoom(new BMap.Point(point[0],point[1]), 13);
            //     this.mapView.addOverlay(marker);
            //     marker.setLabel(addressName);
            // }, 0);
        }
        this.mapView = map;
        this.bdGEO();
    }
    convertjwd(lat,lng,type,callback){
        let params = {
            token:this.props.userInfo.token,
            data:{
                position:lat+'_'+lng,
                type:type,
            }
        }
        translate(params).then((res) => {
            if (res.data.code === '0000') {
                return callback(res.data.data)
            }else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }else {
                Toast.info(res.data.msg);
            }
        })
    }
    bdGEO =() =>{
        if(typeof addressData == 'undefined'){
            return;
        }
        //addressData -> 地址列表
        addressData.forEach(element => {
            //循环取出地址，并将每个地址都调用geocodeSearch，将该地址的点填充到map中
            this.geocodeSearch(element,'address');
        });
        if(typeof SitesData == 'undefined'){
            return;
        }
        //SitesData -> 地址列表
        SitesData.forEach(element => {
            //循环取出地址，并将每个地址都调用geocodeSearch，将该地址的点填充到map中
            this.geocodeSearch(element,'sites');
        });
    }
    geocodeSearch = (addressDatas,type) =>{
        let myGeo = new BMap.Geocoder();
        if(index < addressDatas.length){
            setTimeout(window.bdGEO,400);
        } 
        let that = this;
        myGeo.getPoint(addressDatas, function(){
            // let point = addressDatas.location.split('_').reverse();
            // let address = new BMap.Point(point[0], point[1]);
            // let addressName = addressDatas.locationName;
            // that.addMarker(address,type,new BMap.Label(addressName,{offset:new BMap.Size(20,-10)}));
            that.convertjwd(addressDatas.location.split('_')[0],addressDatas.location.split('_')[1],5,(r)=>{
                console.log(r)
                let address = new BMap.Point(r.split('_')[1], r.split('_')[0]);
                console.log(address)
                let addressName = addressDatas.locationName;
                that.addMarker(address,type,new BMap.Label(addressName,{offset:new BMap.Size(20,-10)}));
            })
        },);
    }
    //把循环出来的点标注在地图上
    addMarker =(point,type,label) =>{
        if(type == 'sites'){
            var myIcon = new BMap.Icon(positionIcon, new BMap.Size(100,157), {
                offset: new BMap.Size(10, 25),
                imageOffset: new BMap.Size(0, 0 -  index * 25)
            });
            let marker = new BMap.Marker(point,{icon:myIcon });
            this.mapView.centerAndZoom(new BMap.Point(point.lng,point.lat), 13);
            this.mapView.addOverlay(marker);
            marker.setLabel(label);
        }else{
            let marker = new BMap.Marker(point);
            this.mapView.centerAndZoom(new BMap.Point(point.lng,point.lat), 13);
            this.mapView.addOverlay(marker);
            marker.setLabel(label);
        }
    }

    //订单预览
    getOrderDetail=()=>{
        if(this.state.dispatchData){
            let params = {
                token: this.props.userInfo.token,
                "data":
                {
                    "id":this.props.location.state.dispatchData[0].shuntConbinationId
                }
            };
            orderPreview(params)
                .then((res) => {
                    console.log(res)
                    if (res.data.code === '0000') {
                        let startTime =  moment(new Date(res.data.data.shuntConStartTime)).format("YYYY年MM月DD日 HH:ss:mm")
                        this.setState({
                            id:res.data.data.shuntOrderConbinationId,
                            dispatchStartTime:startTime,
                            dispatchPrice:res.data.data.price,
                            reassignmentCount:res.data.data.reassignmentCount,
                            shuntOrderConbinationId:res.data.data.shuntOrderConbinationId
                        })
                    }
                    else if (res.data.code === '1401') {
                        document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                    }
                    else {
                        Toast.info(res.data.msg);
                    }
                }).catch(function (error) {
                console.log(error);
            });
        }
       
    };
    totalAmount=()=>{
        let amount = 0;
        if(this.state.data){
            this.state.data.forEach((e)=>{
                amount += e.price
            })
            this.setState({
                amount:amount
            })
        }
    };
  //关闭接口
  delete = () =>{
    let params = {
        "token": this.props.userInfo.token,
        "data":{
            "shuntOrderCombinationId":this.state.id,
            "closeType": 2
        }
     };
     closeOrder(params)
         .then((res) => {
             console.log(res)
             if (res.data.code === '0000') {
                Toast.info('关闭成功',3,this.props.history.goBack());
             }
             else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
             }
             else {
                 Toast.info(res.data.msg);
             }
         }).catch(function (error) {
         console.log(error);
     });
};
    btnSendOrder=()=>{
        let params = {
            token: this.props.userInfo.token,
            "data":this.IdData
        };
        // return;
        confirmOrder(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                   this.setState({
                       showModal:true
                   })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    assign(){
        let params = {
            token: this.props.userInfo.token,
            data:shuntOrderIds,
        };
        resendorder(params).then((res)=>{
            console.log(res.data.data)
        })
        // this.props.history.push('/drivers', {dispatchId:shuntOrderIds})
    }
    render() {
        return (
            <div className="billView">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >{this.state.data ? "发单预览":"订单预览"}</NavBar>
                <div className="address">
                {
                    this.state.show ? 
                        this.state.data ? 
                            (
                                this.state.data.map((res, i) => (
                                    <div className="location" key={i}>
                                        <div className="line"><span>{res.shiftName}</span>行程时间：{res.shiftTime}</div>
                                        {res.orderType == '送' ? <div className="send">
                                            <div><i className="icon iconfont icondaixiadanchufadi"></i>{res.vicinageStationName}</div> 
                                        </div>:null}
                                        <div>
                                            <i className={res.orderType == '接' ? 'icon iconfont icondaixiadanchufadi' : 'icon iconfont icondaixiadanmudedi'}></i>
                                            {res.orderType == "接" ? res.startAddress : res.endAddress}
                                        </div>
                                        {res.orderType == '接' ?  <div className="deliver">
                                           <div><i className="icon iconfont icondaixiadanmudedi"></i>{res.vicinageStationName}</div>
                                        </div> :null}
                                    </div>
                                   
                                )) 
                            ): (
                                <div>
                                    {this.state.cityDispatch == 0 ?<div>订单号：Aptx99855</div>:null}
                                    {
                                        this.state.dispatchData.map((res,i) => (
                                            this.state.dispatchData[i].orderDetails.map((res,i)=>(
                                                <div className="location" key={i}>
                                                    <div className="line"><span>{res.shiftName}</span>行程时间：{res.shiftTime}</div>
                                                    <div className="send">
                                                        {res.orderType == '送' ? 
                                                            <div><i className="icon iconfont icondaixiadanchufadi"></i>{res.vicinageStationName}</div> 
                                                        :null}
                                                    </div>
                                                    <div>
                                                        <i className={res.orderType == '接' ? 'icon iconfont icondaixiadanchufadi' : 'icon iconfont icondaixiadanmudedi'}></i>
                                                        {res.address}</div>
                                                    <div className="deliver">
                                                        {res.orderType == '接' ? <div><i className="icon iconfont icondaixiadanmudedi"></i>{res.vicinageStationName}</div> 
                                                        :null}
                                                    </div>
                                                </div>
                                            ))
                                        ))
                                    }
                                </div>
                            )
                        : null
                }
                    <div className="spread" onClick={()=>this.setState({show:!this.state.show})}>
                        {this.state.show ? <i className="icon iconfont iconzhedie"></i> : <i className="icon iconfont iconzhankai"></i> }
                    </div>
                </div>
                <div  id="allmap"></div>
                {
                    this.state.dispatch ==0 ? <div className="footerContentA">
                        <div className="header">
                            <span>预计时间</span>
                            <div>{this.props.history.location.state.startTime}</div>
                        </div>
                        <div className="footer">
                            <div>总计<span>¥{this.props.history.location.state.finalPrice}</span></div>
                            <div onClick={()=>this.setState({sendOrder:true})}>确认发单</div>
                        </div>
                        </div> :<div className="footerContentB">
                                    <div className="header">
                                        <div>
                                            <span>预计出发时间</span>
                                            <div>{this.state.dispatchStartTime}</div>
                                        </div>
                                        <div>
                                            <span>费用总计</span>
                                            <p>¥{this.state.dispatchPrice}</p>
                                        </div>
                                        <div>
                                            <span>拒单次数</span>
                                            <div>{this.state.refuse}</div>
                                        </div>
                                        </div>
                                        <div className="footer">
                                            <div onClick={()=>this.setState({closeModal:!this.state.closeModal})}>关闭订单</div>
                                            <div onClick={() => this.props.history.push('/drivers',
                                                 {dispatchId:this.props.location.state.dispatchData[0].shuntConbinationId})}>派单</div> 
                                        </div>
                                </div>
                }
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.closeModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '取消', onPress: () => { this.setState({closeModal:!this.state.closeModal}); } },{ text: '确定', onPress: () => { this.setState({closeModal:!this.state.closeModal});this.delete() } }]}
                >
                    <div className="modalTitle">
                        <div>是否确认关闭？</div>
                        <div>关闭订单乘客将变为不分流</div>
                    </div>
                </Modal>
                <Modal
                    popup
                    closable
                    visible={this.state.sendOrder}
                    animationType="slide-up"
                    maskClosable={true}
                    onClose={()=>this.setState({sendOrder:false})}
                    className="sendOrder"
                    title={"选择派单方式"}
                >
                    <div className="btnBox">
                        <div className="jiesuo zhipai"  onClick={()=>this.props.history.push('/drivers', {dispatchId:shuntOrderIds})}>指派</div>
                      <div className="jiesuo fadan" onClick={()=>this.btnSendOrder()}>发单</div>
                    </div>
                </Modal>
                <Modal
                    className="billViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '知道了', onPress: () => { this.setState({showModal:!this.state.showModal}); this.props.history.goBack()} }]}
                >
                <div className="modalTitle">
                    <div>发单成功!</div>
                    <div>抢单中，请及时关注抢单进度</div>
                </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/CityService/BillView/index.js